/**
 *
 * @param $location
 * @param $auth
 * @returns {*}
 */
export function loginRequiredActive(
  $location,
  $auth
) {
  'ngInject';
  if( false === $auth.isAuthenticated() ){
    $location('signin');
  }
}

/**
 *
 * @param $location
 * @param $auth
 * @param $stateParams
 * @returns {*}
 */
export function userOrAdminActive(
  $location,
  $auth,
  $stateParams
) {
  'ngInject';
  const user = $auth.getUser();
  if( user.admin ){
    return true;
  }
  if( user.id != parseInt($stateParams.id) ){
    return $location('signin');
  }
}

function getRouteName(name) {
  const devider = '/:';
  return name.indexOf(devider) > -1 ? name.split(devider)[0] : name;
}

/**
 *
 * @param name
 * @param loginRequired
 * @param userOrAdmin
 * @returns {{name: string, url: string, template: string}}
 */
function componentRouterActive(
  name,
  loginRequired ,
  userOrAdmin
) {
  let router = {
    name    : `${getRouteName(name)}`,
    url     : `/${name}`,
    template: `<${name}></${name}>`
  };
  if( loginRequired ){
    router.resolve.loginRequired = loginRequiredActive;
  }
  if( userOrAdmin ) {
    router.resolve.userOrAdmin = userOrAdminActive;
  }
  return router;
}

export default componentRouterActive;


/** WEBPACK FOOTER **
 ** ./frontend/@/componentRouter.active.js
 **/